import { render, staticRenderFns } from "./FormSummary.vue?vue&type=template&id=7a63f89f"
import script from "./FormSummary.vue?vue&type=script&lang=js"
export * from "./FormSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/www-root/data/www/view.sessiondesign.ru/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a63f89f')) {
      api.createRecord('7a63f89f', component.options)
    } else {
      api.reload('7a63f89f', component.options)
    }
    module.hot.accept("./FormSummary.vue?vue&type=template&id=7a63f89f", function () {
      api.rerender('7a63f89f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/front/shared/components/FormSummary.vue"
export default component.exports